<template>
    <v-row justify="center">
        <v-dialog v-model="open" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title v-if="id">Editar grafica</v-toolbar-title>
                    <v-toolbar-title v-else>Nueva grafica</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-form ref="form" class="text-center">
                        <v-subheader>Nombre de la grafica</v-subheader>
                        <v-card outlined>
                            <v-card-text>
                                <v-text-field 
                                    v-model="name" 
                                    label="Agregue un nombre" 
                                    hide-details
                                    class="pa-1"
                                ></v-text-field>   
                            </v-card-text>
                        </v-card>
                        <v-subheader>Propiedades</v-subheader>
                        <v-card outlined>
                            <v-card-text>
                                <v-btn-toggle
                                    v-model="props"
                                    color="primary"
                                    dense
                                    multiple
                                    active-class="active"
                                    class="props"
                                    borderless
                                >
                                    <v-btn :value="KWH" block color="white" class="mb-3" @click="selectProp(KWH)" :disabled="props.includes(WATTS) || props.includes(AMPS) || props.includes(VOLTS)">
                                        {{ KWH }}
                                    </v-btn>

                                    <v-btn :value="WATTS" block color="white" class="mb-3" @click="selectProp(WATTS)" :disabled="props.includes(KWH)">
                                        {{ WATTS }}
                                    </v-btn>

                                    <v-btn :value="AMPS" block color="white" class="mb-3" @click="selectProp(AMPS)" :disabled="props.includes(KWH)">
                                        {{ AMPS }}
                                    </v-btn>

                                    <v-btn :value="VOLTS" block color="white" class="mb-3" @click="selectProp(VOLTS)" :disabled="props.includes(KWH)">
                                        {{ VOLTS }}
                                    </v-btn>

                                </v-btn-toggle>
                            </v-card-text>
                        </v-card>

                        <v-subheader>Lineas</v-subheader>
                        <v-card outlined>
                            <v-card-text>
                                <v-btn-toggle
                                    v-model="lines"
                                    multiple
                                    active-class="active"
                                    borderless
                                >
                                    <v-btn :value="LINE1" rounded color="white" :disabled="props.includes(KWH)">
                                        <v-icon>mdi-numeric-1-box-outline</v-icon>
                                    </v-btn>

                                    <v-btn :value="LINE2" rounded color="white" class="mx-3" :disabled="props.includes(KWH)">
                                        <v-icon>mdi-numeric-2-box-outline</v-icon>
                                    </v-btn>

                                    <v-btn :value="LINE3" rounded color="white" :disabled="props.includes(KWH)">
                                        <v-icon>mdi-numeric-3-box-outline</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue-grey lighten-1" dark @click="close" small>Cancelar</v-btn>
                    <v-btn color="accent" dark @click="save" small>Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="error.active" :timeout="3000">
            {{ error.message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    @click="error.active = false"
                >
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
    </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { WATTS, AMPS, VOLTS, KWH } from '../components/graphs/props-types'
import { COLUMS, LINES } from '../components/graphs/props-types'
import { LINE1, LINE2, LINE3 } from '../components/graphs/props-types'

export default {
    name: 'newGraph',
    props: ['open', 'meter', 'id'],
    computed: {
        ...mapGetters({ getChart: 'graphs/getChart' })
    },
    data() {
        return {
            valid: false,
            name: '',
            lines: [],
            props: [],
            type: LINES,
            WATTS, AMPS, VOLTS, KWH,
            COLUMS, LINES,
            LINE1, LINE2, LINE3,
            error: {
                message: '',
                active: false
            }
        }
    },
    watch:{
        id(){
            if(this.id){
                let chart = this.getChart(this.meter, this.id)
                this.name = chart.name
                this.lines = chart.lines
                this.type = chart.type
                this.props = chart.props       
            }
        }
    },
    methods: {
        ...mapActions( { 
            newChart: 'graphs/newChart',
            updateChart: 'graphs/updatedChart' 
        }),
        selectProp(prop){
            if(prop != KWH) return this.type = LINES

            this.type = COLUMS
            this.props = [KWH]
            this.lines = [LINE1]
        },
        async save(){
            if(!this.validate()) {
                this.error.message = 'Falta rellenar campos'
                this.error.active = true
                return
            }
            
            this.id ? this.editChart(): this.createChart()
        },
        async createChart(){
            try {
                 await this.newChart({
                    new_chart: {
                        name: this.name,
                        lines: this.lines,
                        props: this.props,
                        type: this.type
                    },
                    meter: this.meter
                })
                this.reset()
                this.$emit('changes')
            } catch (error) {
                this.error.message = error.message
                this.error.active = true
            }
        },
        async editChart(){
            try {
                 await this.updateChart({
                    updated_chart: {
                        id: this.id,
                        name: this.name,
                        lines: this.lines,
                        props: this.props,
                        type: this.type
                    },
                    meter: this.meter
                })
                
                this.reset()
                this.$emit('changes', this.id)
            } catch (error) {
                this.error.message = error.message
                this.error.active = true
            }
        },
        validate(){
            let valid = this.name !== '' && this.lines.length > 0  && this.props.length > 0  && this.type !== undefined 
            return valid
                
        },
        close(){
            this.reset()
            this.$emit('close')
        },
        reset(){
            this.name = ''
            this.lines = []
            this.props = []
            this.type = null
        }
    },
}
</script>

<style scoped>
.btn-type{
    height: 100% !important;
    width: 110px;
    border-radius: 5px !important;
    border: 0px !important;
}
.active{
    background-color: var(--v-accent-base) !important;
    color: white !important;
}
.props{
    display: block !important;
}
</style>